import React, { useState } from 'react'
import { useModalProvider } from '../../../../../../../Providers/ModalProvider'

import { ModalTitleAndCloseButton } from "../ModalTitleAndCloseButton"
import { PatientFile } from "../../../Types/PatientFile"

import { MobergButton, MobergButtonShape, MobergButtonVariant } from "../../../../../../../Components/MobergButton/MobergButton"
import { MobergTheme } from "../../../../../../../Components/MobergThemes/MobergColors"
import { MobergFontSize } from "../../../../../../../Components/MobergFont/MobergFont"
import { MobergColumn, MobergRow } from '../../../../../../../Moberg'
import ConfirmationModal from '../../../../../../../Components/ConfirmationModal/ConfirmationModal'
import { Deployment, useEnvironmentVariablesProvider } from "../../../../../../../Providers/EnvironmentVariablesProvider";
import { PatientFileDropdown } from './PatientFileDropdown'
import { useNavigate } from 'react-router-dom'
import { FRONTEND_LINKS } from '../../../../../../../Constants/FrontendLinks'


type SelectPatientFilesModalProps = {
    patientFiles: PatientFile[]
    selectedPatientKey: number
    selectedPatientID: number
    selectedSiteName: string
    selectedPatientName?: string
}

export const SelectPatientFilesModal = (props: SelectPatientFilesModalProps) => {
    const navigate = useNavigate()
    const { close } = useModalProvider()
    const [selectedPatientFile, setSelectedPatientFile] = useState<PatientFile | undefined>(props.patientFiles.length > 0 ? props.patientFiles[0] : undefined)
    const { deployment } = useEnvironmentVariablesProvider()
    const isClinical = deployment === Deployment.CLINICAL

    const filteredPatientFiles = props.patientFiles
        .filter(file => file && (file.file_name || file.obj_name) && (file.id !== undefined && file.id !== null || file.obj_id !== undefined && file.obj_id !== null))


    function handleSelectPatientFile() {
        const fileName = selectedPatientFile?.file_name || selectedPatientFile?.obj_name || '';
        const fileId = selectedPatientFile?.id || selectedPatientFile?.obj_id;

        navigate(
            `${FRONTEND_LINKS.SUBPAGES.DATA.SUBPAGES.REVIEW.MAIN}/${props.selectedPatientKey}/${props.selectedPatientID}/${encodeURIComponent(props.selectedSiteName)}/${fileId}/${encodeURIComponent(fileName)}`,
        )
    }

    if (filteredPatientFiles.length === 0) {
        return (
            <ConfirmationModal
                title={"No Patient Recordings"}
                description={"There are no patient recordings available for review."}
                confirmButton={{ text: "OK", theme: MobergTheme.BLUE }}
                showCancelButton={false}
            />
        )
    }

    return (
        <div style={{ width: "600px", padding: "0", display: "flex", flexDirection: "column" }}>
            <ModalTitleAndCloseButton title={"Select a Patient File"} closeFunction={close} />
            <MobergColumn gap="24px" style={{ padding: "24px", width: '100%' }}>
                <MobergColumn gap="12px">
                    <div style={{ 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "space-between",
                        marginBottom: "4px"
                    }}>
                        <div style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "var(--color-text-primary)"
                        }}>
                            Select a file for review
                        </div>
                        {!isClinical && (
                            <div style={{
                                color: "var(--text-secondary-color)",
                                fontSize: "12px", 
                                fontWeight: "500",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px"
                            }}>
                                Preload Status
                            </div>
                        )}
                    </div>
                    <PatientFileDropdown
                        options={filteredPatientFiles}
                        selectedValue={selectedPatientFile}
                        onChange={setSelectedPatientFile}
                        width={"100%"}
                        style={{ width: "100%" }}
                        isClinical={isClinical}
                    />
                </MobergColumn>
                <MobergRow horizontalAlign="end" style={{ marginTop: "8px" }}>
                    <MobergButton
                        onClick={handleSelectPatientFile}
                        disabled={selectedPatientFile && !selectedPatientFile.file_exists}
                        theme={MobergTheme.BLUE}
                        variant={MobergButtonVariant.FILLED}
                        fontSize={MobergFontSize.LARGE}
                        shape={MobergButtonShape.WIDE}
                        style={{ minWidth: "120px" }}>
                        View file
                    </MobergButton>
                </MobergRow>
            </MobergColumn>
        </div>
    )
}
